import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_RIPPLE_GLOBAL_OPTIONS, MatNativeDateModule, RippleGlobalOptions } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { I18nModule } from '@spartacus/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { DynamicFormsComponent } from './dynamic-forms.component';
import { DynamicFormsMaterialUIModule } from './ui-material/dynamic-material-form-ui.module';
const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 0,
    exitDuration: 0,
  },
};
@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    DynamicFormsMaterialUIModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    DynamicFormsComponent,
  ],
  exports: [DynamicFormsComponent],
  providers: [
    MatDatepickerModule,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', float: 'always' } },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
  ],
})
export class DynamicFormsModule {}
